import React, { useState, useEffect, useCallback, useMemo, useRef } from 'react';
import { api, fetchBackgroundUrl } from '../../api';
import { Wheel as RouWheel } from 'react-custom-roulette';
import { Howl } from 'howler';
import { Loader2 } from 'lucide-react';
import './Wheel.css';
import CustomWheelFrame from '../../components/customWheel/CustomWheelFrame';
import SpinWheelModal from '../../components/spinWheelModal/SpinWheelModal';
import PrimaryButton from '../../components/button/primaryButton';
import { Settings } from "lucide-react";
import { useNavigate } from 'react-router-dom';
import UserInfoForm from '../../components/userInfoForm';
import WinnerModal from '../../components/winnerModal';
import { toast } from 'react-toastify';
import './Loader.css';
import zIndex from '@mui/material/styles/zIndex';
const logo = require('../../assets/logo.jpg');

const buttonStyle = {
    background: "transparent",
    border: "none",
    cursor: "pointer",
    color: '#fff'
};

const sound = new Howl({
    src: ['tick.mp3'],
    loop: false,
});

const backgroundColors = [
    "#84CC16", "#10B981", "#7C3AED", "#DC2626", "#F97316",
    "#94A3B8", "#1E3A5F", "#38BDF8", "#FACC15", "#A3E635"
];
const textColors = ['#FFFFFF'];
const outerBorderColor = 'transparent';
const outerBorderWidth = 0;
const innerBorderColor = '#D4AF37';
const innerBorderWidth = 3;
const innerRadius = 20;
const radiusLineColor = 'rgba(255, 255, 255, 0.35)';
const radiusLineWidth = 2;
const fontFamily = 'Nunito';
const fontWeight = 'bold';
const fontSize = 14;
const fontStyle = 'normal';
const textDistance = 58;
const spinDuration = 1.0;
const pointerProps = { style: { opacity: 0, width: 0, height: 0 } };

const wheelProps = {
    backgroundColors,
    textColors,
    outerBorderColor,
    outerBorderWidth,
    innerRadius,
    innerBorderColor,
    innerBorderWidth,
    radiusLineColor,
    radiusLineWidth,
    fontFamily,
    fontWeight,
    fontStyle,
    spinDuration,
    pointerProps,
};

const tvWheelProps = {
    ...wheelProps,
    fontSize: 26,
    textDistance: 62,
};

const previewWheelProps = {
    ...wheelProps,
    fontSize,
    textDistance,
};

const truncateText = (text, maxLength = 20) => {
    return text.length > maxLength ? text.substring(0, maxLength) + "..." : text;
};

export default function Wheel() {
    const navigate = useNavigate();
    const [loading, setLoading] = useState(false);
    const [mustSpin, setMustSpin] = useState(false);
    const [prizes, setPrizes] = useState([]);
    const [prizeNumber, setPrizeNumber] = useState(0);
    const [isShowModalInfo, setIsShowModalInfo] = useState(true);
    const userInfo = useRef();
    const [isShowModalWinner, setIsShowModalWinner] = useState(false);
    const [isShowSpinModal, setIsShowSpinModal] = useState(false);
    const [isSpinLoading, setIsSpinLoading] = useState(false);
    const [backgroundUrl, setBackgroundUrl] = useState(null);
    const winnnerMessage = useRef();

    const prizesDataWheel = useMemo(() => {

        if (prizes?.length > 0) {
            return prizes?.map(item => {
                return {
                    ...item,
                    option: truncateText(item.name)
                }
            });
        }

        return null;
    }, [prizes]);

    const showToast = useCallback(() => {
        toast.error("Liên hệ người quản trị giải thưởng kiểm tra danh sách, hiện tại không có giải thưởng nào có số lượng lớn hơn 0", {
            position: "top-right",
        });
    }, []);

    const fetchPrizes = useCallback(async () => {
        setLoading(true);
        const response = await api.get('/prizes');
        if (response?.data?.length === 0) {
            setIsShowModalInfo(false);
            setTimeout(() => {
                setLoading(false);


            }, 2000);
            return showToast();


        }
        setPrizes(response.data);
        setLoading(false);

    }, [setIsShowModalInfo, setLoading, setPrizes]);


    const handleCloseInfoModal = useCallback(async (data) => {
        userInfo.current = data;
        const { playerName = '', phone, address, vehical, noCCCD, branch } = data || {};

        const response = await api.post('/users',
            {
                username: playerName,
                phone,
                address,
                purchased_vehicle: vehical,
                cccd: noCCCD,
                branch
            }
        );
        setIsShowModalInfo(false);
    }, [setIsShowModalInfo, userInfo]);


    const disableScroll = useCallback(() => {
        document.body.style.overflow = "hidden";
    }, []);

    const enableScroll = useCallback(() => {
        document.body.style.overflow = "auto";
    }, []);

    const handleSpinClick = useCallback(async () => {
        try {
            if (!userInfo.current) {
                alert('Bạn cần điền thông tin người quay trước khi quay!');
                setIsShowModalInfo(true);
                return;
            }

            disableScroll();
            setMustSpin(false);
            setIsShowSpinModal(true);
            setIsSpinLoading(true);

            const response = await api.post('/spin', { user_name: userInfo.current?.playerName });
            const result = response.data;
            setPrizeNumber(result.index);
            winnnerMessage.current = result?.message;
            setIsSpinLoading(false);

            setTimeout(() => {
                setMustSpin(true);
                let tickInterval = 150;
                let ticks = 0;
                const tickSound = setInterval(() => {
                    sound.play();
                    ticks++;
                    if (ticks > 30) tickInterval += 10;
                    if (ticks > 50) {
                        clearInterval(tickSound);
                        setTimeout(() => {
                            setIsShowSpinModal(false);
                            setIsShowModalWinner(true);
                            enableScroll();
                        }, 6000);
                    }
                }, tickInterval);
            }, 400);
        } catch (error) {
            console.error('Lỗi khi quay thưởng:', error);
            setIsSpinLoading(false);
            setIsShowSpinModal(false);
            enableScroll();
        }
    }, [setPrizeNumber, setIsShowModalWinner, enableScroll, disableScroll, winnnerMessage, userInfo]);


    const handleSettingClick = useCallback(() => {
        navigate("/giaithuong")
    }, [navigate])


    useEffect(() => {
        fetchPrizes();
    }, []);

    useEffect(() => {
        const loadBackground = async () => {
            try {
                const url = await fetchBackgroundUrl();
                if (url) {
                    setBackgroundUrl(url);
                }
            } catch (error) {
                console.error('Không thể tải hình nền từ server:', error);
            }
        };

        loadBackground();
    }, []);

    const handleCloseWinnerModal = useCallback(() => {
        // setIsShowModalWinner(false);
        // fetchPrizes();
        // setTimeout(() => {
        //     setIsShowModalInfo(true);
        // }, 2000)

        // userInfo.current = {};
        // winnnerMessage.current = '';
        setTimeout(() => {
            window.location.reload();
        }, 2000)

    }, []);


    if (loading) return (
        <div className="loader-container">
            <div className="spinner"></div>
        </div>
    )

    return (
        <div
            className="flex flex-col items-center justify-content-center gradient-background"
            style={backgroundUrl ? {
                backgroundImage: `url(${backgroundUrl})`,
                backgroundSize: 'cover',
                backgroundPosition: 'center',
                backgroundRepeat: 'no-repeat',
            } : undefined}
        >
            {isShowModalInfo && <UserInfoForm isShow={true} onSpin={handleCloseInfoModal} onClose={() => setIsShowModalInfo(false)} />}

            <WinnerModal
                isOpen={isShowModalWinner}
                onClose={handleCloseWinnerModal}
                text={winnnerMessage.current}
            />

            <SpinWheelModal
                isOpen={isShowSpinModal}
                playerName={userInfo.current?.playerName}
                isLoading={isSpinLoading}
                mustSpin={mustSpin}
                prizeNumber={prizeNumber}
                data={prizesDataWheel}
                onStopSpinning={() => setMustSpin(false)}
                wheelProps={tvWheelProps}
            />

            <div className='settingBtn'>
                <button style={buttonStyle} onClick={handleSettingClick}>
                    <Settings size={24} />
                </button>
            </div>

            {/* <div className="rgba-background justify-content-center justify-items-center text-center">
                <div className='header'>
                    <h1 className="text-2xl font-bold mb-4">MUA XE HÔM NAY NHẬN NGAY QUÀ TẶNG</h1>
                </div>
            </div> */}

            <div className="two-columns justify-content-center" >
                <img src={logo} className='logoBC' alt="Bảo Cường Group" />
                <div className="column wheel-section justify-content-center justify-items-center text-center">
                    {prizesDataWheel && <PrimaryButton title={'Quay Ngay!'} onClick={handleSpinClick} />}

                    {prizesDataWheel?.length > 0 && (
                        <div className="wheel-scale">
                            <CustomWheelFrame>
                                <RouWheel
                                    mustStartSpinning={false}
                                    prizeNumber={0}
                                    data={prizesDataWheel}
                                    backgroundColors={previewWheelProps.backgroundColors}
                                    textColors={previewWheelProps.textColors}
                                    fontFamily={previewWheelProps.fontFamily}
                                    fontSize={previewWheelProps.fontSize}
                                    fontWeight={previewWheelProps.fontWeight}
                                    fontStyle={previewWheelProps.fontStyle}
                                    outerBorderColor={previewWheelProps.outerBorderColor}
                                    outerBorderWidth={previewWheelProps.outerBorderWidth}
                                    innerRadius={previewWheelProps.innerRadius}
                                    innerBorderColor={previewWheelProps.innerBorderColor}
                                    innerBorderWidth={previewWheelProps.innerBorderWidth}
                                    radiusLineColor={previewWheelProps.radiusLineColor}
                                    radiusLineWidth={previewWheelProps.radiusLineWidth}
                                    spinDuration={previewWheelProps.spinDuration}
                                    textDistance={previewWheelProps.textDistance}
                                    pointerProps={previewWheelProps.pointerProps}
                                />
                            </CustomWheelFrame>
                        </div>
                    )}
                </div>
            </div>

            <div className="footer">
                <div className="marquee">
                    <span>Hotline: 0941.003.456</span>
                    <span>Cơ sở 1: 86 Lê Duẩn - tt Khe Sanh</span>
                    <span>Cơ sở 2: 172 Lê Duẩn - tt Khe Sanh</span>
                    <span>Cơ sở 3: 115 Lê Duẩn - tt Khe Sanh</span>
                    <span>Cơ sở 4: 03 Lý Thường Kiệt, tt Lao Bảo</span>
                    <span>Cơ sở 5: 509 Lê Duẩn, tt Krông-Klang Đakrông</span>
                </div>
            </div>
        </div >
    );
}
